import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import HomePage from "@/pages/HomePage";
import RSVPPage from "@/pages/RSVPPage";
import GalleryPage from "@/pages/GalleryPage";
import RegistryPage from "@/pages/RegistryPage";
import FotoRicordoPage from "@/pages/FotoRicordoPage";
import AdminPage from "@/pages/AdminPage";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";

const TOAST_OPTIONS = {
  style: { fontFamily: "'Manrope', sans-serif" },
};

function App() {
  return (
    <BrowserRouter>
      <Toaster
        position="top-center"
        richColors
        toastOptions={TOAST_OPTIONS}
      />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Navigation />
              <HomePage />
              <Footer />
            </>
          }
        />
        <Route
          path="/rsvp"
          element={
            <>
              <Navigation />
              <RSVPPage />
              <Footer />
            </>
          }
        />
        <Route
          path="/galleria"
          element={
            <>
              <Navigation />
              <GalleryPage />
              <Footer />
            </>
          }
        />
        <Route
          path="/lista-nozze"
          element={
            <>
              <Navigation />
              <RegistryPage />
              <Footer />
            </>
          }
        />
        <Route
          path="/foto-ricordo"
          element={
            <>
              <Navigation />
              <FotoRicordoPage />
              <Footer />
            </>
          }
        />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
